import {Component, inject, input, output} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MinutesPipe} from '../../pipes/minutes.pipe';
import {CompanyNamePipe} from '../../pipes/company-name.pipe';
import {DatePipe} from '@angular/common';
import {RegistrationV2} from '../../classes/registration';
import {Project} from '../../classes/project';
import {Company} from '../../classes/company';
import {HasRolePipe} from '../../pipes/has-role.pipe';
import {Roles} from '../auth/roles';
import {forkJoin} from 'rxjs';
import {RegistrationService} from '../registration.service';
import {CodaltComponent} from '../../codalt.component';

export interface DayUser {
    userId: number;
    name: string;
    totalMinutes: number;
    registrations: ReportRegistration[];
}

export type ReportRegistration = RegistrationV2 & { project: Project, comments: ReportComment[], lightStart: boolean, lightEnd: boolean };

export interface ReportComment {
    id: number;
    user_id: number;
    description: string;
    datetime: string;
}

@Component({
    selector: 'registrations-by-day',
    templateUrl: './registrations-by-day.component.html',
    styleUrls: ['./registrations-by-day.component.scss'],
    imports: [
        ReactiveFormsModule,
        MinutesPipe,
        CompanyNamePipe,
        DatePipe,
        HasRolePipe,
    ]
})
export class RegistrationsByDayComponent extends CodaltComponent {
    registrationDay = input.required<{ date: string, users: DayUser[] }>();
    companies = input.required<Company[]>();
    showUser = input.required<boolean>();
    showCompany = input.required<boolean>();
    contextMenuFn = input<(registration: ReportRegistration, event: MouseEvent) => void>();

    readonly approved = output<void>();

    readonly Roles = Roles;

    private registrationService = inject(RegistrationService);

    approveDateRegistrations(users: DayUser[]): void {
        const allRegistrationIds = users
            .flatMap(u => u.registrations)
            .filter(r => !r.approved_at)
            .map(r => r.id);

        if (!allRegistrationIds?.length) {
            return;
        }

        this.subscriptions.add(
            forkJoin(allRegistrationIds.map(id => this.registrationService.approveRegistration(id))).subscribe({
                next: () => this.approved.emit(),
                error: err => console.error(err)
            })
        );
    }
}
